export enum FieldVisibility {
  Hide = 0,
  Show = 1,
}

export interface FieldVisibilityOption {
  type: FieldVisibilityType;
  visibility: FieldVisibility;
}

export enum FieldVisibilityType {
  IsActive = 0,
  Searchable = 1,
  ShowPrices = 2,
  ShowPricesAsType = 3,
  DiscountCode = 4,
  DiscountCodeOnCheckout = 5,
  MandatoryDiscountCode = 6,
  GoogleCaptcha = 7,
  SocialLinks = 8,
  VatAvailability = 9,
  ShowCategory = 10,
  ExternalLogin = 11
}
